import { createFileRoute, Link } from "@tanstack/react-router";

import {
  Layout,
  LayoutAside,
  LayoutBody,
  LayoutContent,
  LayoutHeader,
} from "@/client/components/layout";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/client/components/shad/breadcrumb";

import { Badge } from "@/client/components/shad/badge";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/client/components/shad/card";

import { Button } from "@/client/components/shad/button";
import { IconUserPlus } from "@tabler/icons-react";
import { UserList } from "./-features/UserList";
import { UserCard } from "./-features/UserCard";

export const Route = createFileRoute("/(protected)/settings/admin/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Layout>
      <LayoutHeader>
        <Breadcrumb>
          <BreadcrumbList className="font-bold text-base">
            <BreadcrumbItem>
              <BreadcrumbPage>Admin</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </LayoutHeader>
      <LayoutContent>
        <LayoutBody>
          <UserList />
        </LayoutBody>
        <LayoutAside>
          <div className="h-full space-y-6 animate-in fade-in duration-500">
            <UserCard>
              <Button asChild size="sm" variant="secondary">
                <Link to="/settings/admin/new-user">
                  <IconUserPlus />
                  Add New User
                </Link>
              </Button>
            </UserCard>
          </div>
        </LayoutAside>
      </LayoutContent>
    </Layout>
  );
}
